import { render, staticRenderFns } from "./TopRunnersBox.vue?vue&type=template&id=2c4e6d1a&scoped=true"
import script from "./TopRunnersBox.vue?vue&type=script&lang=js"
export * from "./TopRunnersBox.vue?vue&type=script&lang=js"
import style0 from "./TopRunnersBox.vue?vue&type=style&index=0&id=2c4e6d1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4e6d1a",
  null
  
)

export default component.exports